

import ObjectCard from '../../components/Card/ObjectCard.vue'
import { getCustomTabsList } from './employeeCardCustomTabs.js'
import { getEmployeeIdByUserName } from '../../components/helpers.js'

export default {
  extends: ObjectCard,
  data: function () {
    return {
      typeKeyLocal: 'employee' // @Override
    }
  },
  computed: {
    objectNameImgSrc: function () { // @Override
      const access = this.checkUserAccess(this.getUser())
      if (this.objectSrc && this.objectSrc.honored && access.viewPrivate) {
        return '/delta/dist/star.png'
      } else {
        return null
      }
    },
    objectNameImgTooltip: function () { // @Default
      return 'Выдающийся сотрудник'
    },
    objectNameAdditionalInfo: function () { // @Override
      if (this.objectSrc && this.objectSrc.state === 'dismissed') {
        return 'Уволен'
      } else {
        return null
      }
    },
    objectNameAdditionalInfoStyle: function () { // @Override
      if (this.objectSrc && this.objectSrc.state === 'dismissed') {
        return 'color: var(--q-color-negative); font-style: italic;'
      } else {
        return null
      }
    }
  },
  created: function () {
    if (this.small) {
      this.expandCardBtnHidden = true
      this.indicateChanges = true
    }
  },
  methods: {
    /**
     * ObjectCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Default
    getObjectName: function (objectSrc) {
      return objectSrc.fio || objectSrc.name || objectSrc.key
    },
    // @Default
    getObjectId: function () {
      if (isNaN(this.$route.params.id)) {
        return getEmployeeIdByUserName(this.$route.params.id)
      } else {
        return Promise.resolve(this.$route.params.id)
      }
    },
    // @Override
    getRawCustomTabsList: function (config) {
      config.small = this.small
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user) {
      const access = this.getDefaultAccess()
      access.fullAccess = user.fullAccess
      access.viewFull = user.fullAccess || user.hasOperation('employeesViewFull')
      access.employeeManage = user.hasOperation('employeeManage')

      access.editImage = access.employeeManage
      access.editEmployeeSchedule = user.hasOperation('changeEmployeeSchedule')
      access.editEmployeeSkills = user.hasOperation('changeEmployeeSkills')
      access.viewEmployeeSkills = access.viewFull || access.editEmployeeSkills
      access.editFuelCards = user.hasRole('admin', 'transportAdmin')
      access.viewFuelCards = access.viewFull || access.editFuelCards
      access.editEmployeeAchievements = user.hasOperation('changeEmployeeAchievements')
      access.viewEmployeeAchievements = access.viewFull || access.editEmployeeAchievements
      access.vehicleProvisionApprovalAccess = user.hasOperation('vehicleProvisionApproval')

      access.editPrivate = user.fullAccess
      access.viewPrivate = access.viewFull
      access.viewPublic = !!(access.viewPrivate || user.hasOperation('employeesView'))
      access.editPublic = !!(access.viewPublic && user.hasRole('admin', 'dispatcher', 'transportAdmin'))
      access.editAny = access.editPublic || access.editEmployeeSchedule || access.editEmployeeSkills || access.editImage || access.editFuelCards || access.editEmployeeAchievements
      access.accessControl = user.hasOperation('delta-catalogs-access-control')
      return access
    }
  }
}
